<template>
  <!-- Name will be something like module_competences -->
  <!-- Only loop through arrays longer than 0, with at least one child that is an object -->
  <div
    v-if="
      datas !== null &&
        datas.constructor.name === 'Array' &&
        datas.length > 0 &&
        datas.some((child) => child.constructor.name === 'Object')
    "
    class="col-span-full grid grid-cols-12 gap-x-4 gap-y-5 mb-10"
  >
    <div
      class="col-span-full uppercase text-indigo-600 text-base mx-5 md:mx-10"
    >
      {{
        name === 'module_competences'
          ? 'Compétences'
          : name === 'module_competences_transversales'
            ? 'Compétences transversales'
            : name
      }}
    </div>

    <div
      v-if="datas.length > 0"
      class="col-span-full"
    >
      <!-- display as a table -->
      <div v-if="!$isMobile()">
        <!-- BEGIN list of competences -->
        <div
          v-for="(comp, iComp) in datas"
          :key="iComp + 'comp'"
          class="odd:bg-indigo-100 odd:bg-opacity-50"
        >
          <!-- BEGIN Informations on accordion -->
          <div
            class="h-auto py-5 xl:min-h-24 2xl:min-h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 items-center place-content-center"
            :class="{
              'bg-indigo-200 border-l-2 border-indigo-600':
                competenceDisplayed === iComp,
            }"
            @click="displayCompetence(iComp)"
            :id="'competence' + comp.name + iComp"
          >
            <div
              class="col-span-1 text-pink-600 justify-self-center flex flex-col justify-around"
            >
              <icon
                class="transform transition-transform ease-in-out duration-300"
                :class="{ 'rotate-90': competenceDisplayed === iComp }"
                name="chevron-right"
              />
            </div>
            <div class="col-span-11 text-base font-normal">
              <span>{{ comp.name }}</span>
            </div>
          </div>
          <!-- END informations on accordion -->

          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div v-if="comp.criterions.length > 0">
              <div
                v-show="competenceDisplayed === iComp"
                class="bg-white py-5 md:py-10"
              >
                <div
                  class="text-base text-gray-600 grid grid-cols-10 gap-x-4 mb-10"
                >
                  <div class="col-span-3 ml-10">
                    Critères
                  </div>
                  <div
                    class="col-span-2 text-center"
                    :class="{ 'col-span-3': historyMode }"
                  >
                    Auto-évaluation
                  </div>
                  <div
                    class="col-span-2 text-center"
                    :class="{
                      hidden: (!canSeeRefEval || historyMode) && !previewMode,
                    }"
                  >
                    <span>Dernière eval. ref.</span>
                  </div>
                  <div
                    class="col-span-2 text-center"
                    :class="{ 'col-span-3': historyMode }"
                  >
                    <span :class="{ hidden: !canSeeRefEval && !previewMode }">Nouvelle eval. ref.</span>
                  </div>
                  <div class="col-span-1 text-center">
                    <span :class="{ hidden: !canSeeRefEval && !previewMode }">Comm.</span>
                  </div>
                  <div
                    class="col-start-4 col-span-2 cursor-pointer flex items-center justify-center"
                    :class="{
                      hidden: (!canSeeRefEval || historyMode) && !previewMode,
                    }"
                    @click.stop="hide('auto_' + name)"
                  >
                    <icon
                      :name="!hiddenFields['auto_' + name] ? 'eye-off' : 'eye'"
                      class="h-3 w-4 text-pink-600"
                    />
                    <span class="ml-3 text-sm select-none">
                      {{
                        hiddenFields['auto_' + name] ? 'Afficher' : 'Masquer'
                      }}
                    </span>
                  </div>
                  <div
                    class="col-span-2 flex items-center justify-center cursor-pointer"
                    :class="{
                      hidden: (!canSeeRefEval || historyMode) && !previewMode,
                    }"
                    @click.stop="hide('last_' + name)"
                  >
                    <icon
                      :name="!hiddenFields['last_' + name] ? 'eye-off' : 'eye'"
                      class="h-3 w-4 text-pink-600"
                    />
                    <span class="ml-3 text-sm select-none">
                      {{
                        hiddenFields['last_' + name] ? 'Afficher' : 'Masquer'
                      }}
                    </span>
                  </div>
                </div>

                <div
                  v-for="(critere, iCrit) in comp.criterions"
                  :key="iCrit"
                  class="odd:bg-white odd:bg-opacity-0 bg-indigo-100 bg-opacity-50"
                >
                  <div
                    class="h-auto py-5 xl:min-h-24 2xl:min-h-32 grid grid-cols-10 gap-x-4 place-content-center items-center cursor-default"
                  >
                    <div
                      class="col-span-full md:col-span-3 text-base font-normal flex items-center"
                    >
                      <info-bulle
                        :name="comp.name + critere.name + iCrit"
                        :libelle="critere.indicateur"
                        :size-less="true"
                        class="mx-2"
                      />
                      {{ critere.name }}
                    </div>

                    <input-select
                      v-if="!hiddenFields['auto_' + name] || historyMode"
                      :name="iComp + iCrit + 'auto'"
                      class="md:col-span-2 md:place-self-center"
                      :class="{ 'md:col-span-3': historyMode }"
                      :value="
                        previewMode
                          ? listCriterions[
                            Math.floor(Math.random() * listCriterions.length)
                          ].value
                          : form[iComp].criterions[iCrit].auto
                      "
                      :datas="listCriterions"
                      @input="
                        (newValue) => {
                          setAutoEvaluation(iComp, iCrit, newValue);
                        }
                      "
                      :disabled="historyMode || autoEvalEditable"
                      libelle=""
                    />

                    <div
                      v-else
                      class="col-span-full md:col-span-2"
                    />

                    <input-text
                      v-if="!historyMode && !hiddenFields['last_' + name]"
                      class="md:col-span-2 md:place-self-center"
                      :class="{ hidden: !canSeeRefEval }"
                      :value="
                        Object.keys(
                          (((latestEval || [])[iComp] || {}).criterions || [])[
                            iCrit
                          ] || {}
                        ).length > 0
                          ? (
                            (((latestEval || [])[iComp] || {}).criterions ||
                              [])[iCrit] || {}
                          ).value === null
                            ? 'Non noté'
                            : (
                              (((latestEval || [])[iComp] || {}).criterions ||
                                [])[iCrit] || {}
                            ).value
                          : 'Pas d\'évaluation récente'
                      "
                      :disabled="true"
                      libelle=""
                    />

                    <div
                      v-else-if="!historyMode"
                      class="col-span-full md:col-span-2"
                    />

                    <input-select
                      v-if="canSeeRefEval || historyMode || previewMode"
                      class="md:col-span-2 md:place-self-center"
                      :class="{ 'md:col-span-3': historyMode }"
                      :name="iComp + critere.name + iCrit"
                      :necessary="isNecessary"
                      :value="
                        previewMode
                          ? listCriterions[
                            Math.floor(Math.random() * listCriterions.length)
                          ].value
                          : form[iComp].criterions[iCrit].value
                      "
                      :datas="listCriterions"
                      @input="
                        (newValue) => {
                          setReferentEvaluation(iComp, iCrit, newValue);
                        }
                      "
                      :disabled="historyMode || idPass == idUser"
                    />

                    <div
                      v-else
                      class="col-span-full md:col-span-2"
                    />

                    <icon-comment
                      v-if="canSeeRefEval || historyMode || previewMode"
                      :name="'comment-task-' + iCrit"
                      :value="form[iComp].criterions[iCrit].comment"
                      @input="
                        (newValue) => {
                          setComment(iComp, iCrit, newValue);
                        }
                      "
                      class="md:col-span-1 cursor-pointer md:place-self-center"
                      :disabled="historyMode || idPass == idUser"
                    />
                    <div
                      v-else
                      class="col-span-full md:col-span-1"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else-if="
                competenceDisplayed === iComp && comp.criterions.length === 0
              "
              class="bg-white py-5 md:py-10"
            >
              <div class="text-center text-gray-600">
                Il n'y a pas de critère défini pour cette compétence
              </div>
            </div>
          </transition>
        </div>
      </div>
      <!-- END display as a table -->

      <!-- display on rows (for MOBILE devices) -->
      <div v-if="$isMobile()">
        <!-- BEGIN list of competences -->
        <div
          v-for="(comp, iComp) in datas"
          :key="iComp + 'comp'"
          class="odd:bg-indigo-100 odd:bg-opacity-50"
        >
          <!-- BEGIN Informations on accordion -->
          <div
            class="h-auto py-5 min-h-16 lg:min-h-24 2xl:min-h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 items-center place-content-center"
            :class="{
              'bg-indigo-200 border-l-2 border-indigo-600':
                competenceDisplayed === iComp,
            }"
            @click="displayCompetence(iComp)"
            :id="'competence' + comp.name + iComp"
          >
            <div
              class="col-span-2 text-pink-600 justify-self-center flex flex-col justify-around"
            >
              <icon
                class="transform transition-transform ease-in-out duration-300"
                :class="{ 'rotate-90': competenceDisplayed === iComp }"
                name="chevron-right"
              />
            </div>
            <div class="col-span-10 text-base font-normal">
              <span>{{ comp.name }}</span>
            </div>
          </div>
          <!-- END informations on accordion -->

          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div v-if="comp.criterions.length > 0">
              <div
                v-show="competenceDisplayed === iComp"
                class="bg-white p-5 md:p-10"
              >
                <div
                  v-for="(critere, iCrit) in comp.criterions"
                  :key="iCrit"
                  class="odd:bg-indigo-100 odd:bg-opacity-50"
                >
                  <div
                    class="h-auto py-5 min-h-16 lg:min-h-24 2xl:min-h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 items-center place-content-center"
                    :class="{
                      'bg-indigo-200 border-l-2 border-indigo-600':
                        critDisplayed == iCrit,
                    }"
                    @click="displayCrit(iCrit, critere.name)"
                    :id="'criterion' + critere.name + iCrit"
                  >
                    <div
                      class="col-span-2 text-pink-600 justify-self-center flex flex-col justify-around"
                    >
                      <icon
                        class="transform transition-transform ease-in-out duration-300"
                        :class="{ 'rotate-90': critDisplayed == iCrit }"
                        name="chevron-right"
                      />
                    </div>
                    <div class="col-span-10 text-base line-clamp-3">
                      {{ critere.name }}
                    </div>
                  </div>

                  <transition
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <div
                      v-show="critDisplayed === iCrit"
                      class="bg-white my-5 w-full relative flex flex-col space-y-4 px-5"
                    >
                      <input-text-area
                        libelle="Indicateur"
                        :value="critere.indicateur"
                        :disabled="true"
                        :size="3"
                      />

                      <input-select
                        v-if="!hiddenFields['auto_' + name] || historyMode"
                        :name="iComp + critere.name + iCrit + 'auto'"
                        :disabled="historyMode || autoEvalEditable"
                        :datas="listCriterions"
                        :value="
                          hiddenFields['auto_' + name]
                            ? ''
                            : previewMode
                              ? listCriterions[
                                Math.floor(
                                  Math.random() * listCriterions.length
                                )
                              ].value
                              : form[iComp].criterions[iCrit].auto
                        "
                        @input="
                          (newValue) => {
                            setAutoEvaluation(iComp, iCrit, newValue);
                          }
                        "
                        libelle="Auto-évaluation"
                        libelle-style="text-base text-indigo-600"
                        :libelle-icon="
                          hiddenFields['auto_' + name] ? 'eye-off' : 'eye'
                        "
                        @clickIcon="
                          $can('compsco_auto_eval_read', idPass)
                            ? hide('auto_' + name)
                            : null
                        "
                      />

                      <input-select
                        v-if="hiddenFields['auto_' + name] && !historyMode"
                        :name="iComp + critere.name + iCrit + 'auto'"
                        :disabled="true"
                        :datas="listCriterions"
                        :value="''"
                        libelle="Auto-évaluation"
                        libelle-style="text-base text-indigo-600"
                        :libelle-icon="
                          hiddenFields['auto_' + name] ? 'eye-off' : 'eye'
                        "
                        @clickIcon="
                          $can('compsco_auto_eval_read', idPass)
                            ? hide('auto_' + name)
                            : null
                        "
                      />

                      <input-text
                        v-if="!historyMode"
                        :name="iComp + critere.name + iCrit + 'derniere_eval'"
                        :disabled="true"
                        :value="
                          hiddenFields['last_' + name]
                            ? ''
                            : Object.keys(
                              (((latestEval || [])[iComp] || {}).criterions ||
                                [])[iCrit] || {}
                            ).length > 0
                              ? (
                                (((latestEval || [])[iComp] || {}).criterions ||
                                  [])[iCrit] || {}
                              ).value === null
                                ? 'Non noté'
                                : (
                                  (((latestEval || [])[iComp] || {})
                                    .criterions || [])[iCrit] || {}
                                ).value
                              : 'Pas d\'évaluation récente'
                        "
                        libelle="Dernière évaluation du référent"
                        libelle-style="text-base text-indigo-600"
                        :libelle-icon="
                          hiddenFields['last_' + name] ? 'eye-off' : 'eye'
                        "
                        @clickIcon="hide('last_' + name)"
                      />

                      <input-select
                        v-if="canSeeRefEval || historyMode || previewMode"
                        :class="{ hidden: !canSeeRefEval }"
                        :name="iComp + critere.name + iCrit"
                        :necessary="isNecessary"
                        :datas="listCriterions"
                        :value="
                          previewMode
                            ? listCriterions[
                              Math.floor(
                                Math.random() * listCriterions.length
                              )
                            ].value
                            : form[iComp].criterions[iCrit].value
                        "
                        @input="
                          (newValue) => {
                            setReferentEvaluation(iComp, iCrit, newValue);
                          }
                        "
                        :disabled="historyMode || idPass == idUser"
                        libelle="Nouvelle évaluation du référent"
                        libelle-style="text-base text-indigo-600"
                      />

                      <input-text-area
                        v-if="canSeeRefEval || historyMode || previewMode"
                        :name="'comment-task-' + iCrit"
                        libelle="Commentaire"
                        :value="form[iComp].criterions[iCrit].comment"
                        :size="3"
                        @input="
                          (newValue) => {
                            setComment(iComp, iCrit, newValue);
                          }
                        "
                        :disabled="historyMode || idPass == idUser"
                      />
                    </div>
                  </transition>
                </div>
              </div>
            </div>
            <div
              v-else-if="
                competenceDisplayed === iComp && comp.criterions.length === 0
              "
              class="bg-white py-5 md:py-10"
            >
              <div class="text-center text-gray-600">
                Il n'y a pas de critère défini pour cette compétence
              </div>
            </div>
          </transition>
        </div>
      </div>
      <!-- END display on rows (for MOBILE devices) -->
    </div>
  </div>
</template>

<script>
import InputSelect from './../Inputs/InputSelect.vue';
import InputText from './../Inputs/InputText.vue';
import IconComment from './../Inputs/IconComment.vue';
import InfoBulle from './../InfoBulle.vue';
import Icon from './../Icon.vue';
import InputTextArea from '../Inputs/InputTextArea.vue';
import {mapGetters} from 'vuex';

export default {
  name: 'ModuleCategory',

  components: {
    InputSelect,
    IconComment,
    InputText,
    InfoBulle,
    Icon,
    InputTextArea,
  },
  props: {
    name: {
      type: String,
      required: false,
      default: '',
    },
    idPass: {
      type: Number,
    },
    idUser: {
      type: Number,
    },
    hiddenFields: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    datas: {
      type: Array,
      required: false,
      default: [],
    },
    listCriterions: {
      type: Array,
      required: false,
      default: [],
    },
    latestEval: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    historyMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    previewMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    form: {
      type: Array,
      required: false,
      default: [],
    },
    isNecessary: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      competenceDisplayed: -1,
      critDisplayed: -1,
    };
  },

  methods: {
    setAutoEvaluation(numCompetence, numCritere, newValue) {
      this.$emit('setAutoEvaluation', numCompetence, numCritere, newValue);
    },
    setReferentEvaluation(numCompetence, numCritere, newValue) {
      this.$emit('setReferentEvaluation', numCompetence, numCritere, newValue);
    },
    setComment(numCompetence, numCritere, newValue) {
      this.$emit('setComment', numCompetence, numCritere, newValue);
    },
    hide(field) {
      this.$emit('hideField', field);
    },
    displayCompetence(numCompetence) {
      if (this.competenceDisplayed === numCompetence) {
        this.competenceDisplayed = -1;
      } else {
        this.competenceDisplayed = numCompetence;
        let pos = document.getElementById(
          'competence' + this.datas[numCompetence].name + numCompetence
        );
        setTimeout(() => {
          pos.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 800);
      }
    },

    displayCrit(numCrit, nameCrit) {
      if (this.critDisplayed === numCrit) {
        this.critDisplayed = -1;
      } else {
        this.critDisplayed = numCrit;
        let pos = document.getElementById('criterion' + nameCrit + numCrit);
        setTimeout(() => {
          pos.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 800);
      }
    },
  },
  computed: {
    autoEvalEditable() {
      let isNeopassOwner = parseInt(this.idPass) === this.idUser,
        canEdit = this.$can('compsco_auto_eval_edit', this.idPass);
      return !(!isNeopassOwner ^ !canEdit);
    },
    ...mapGetters({
      user: 'auth/user'
    }),
    canSeeRefEval() {
      const isSelfEval = this.idPass == this.idUser;

      if (isSelfEval && this.user?.companies[0]?.id === 5) {
        return true;
      }

      return !isSelfEval;
    }
  },
};
</script>
